import AreaManage from './Index.vue'

AreaManage.install = function(Vue) {
  Vue.component(AreaManage.name, AreaManage)
}

export { AreaManage }
